export default class StateModel {
  sigla!: string;

  nome!: string;
}
